import { render, staticRenderFns } from "./InstitutionCard.vue?vue&type=template&id=41bf843e&"
import script from "./InstitutionCard.vue?vue&type=script&lang=js&"
export * from "./InstitutionCard.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports